<script setup>
  import { computed } from 'vue'
  import EventSearchWidget from "@/components/Query/EventSearchWidget.vue"
  import SearchHistory from "@/components/Account/SearchHistory.vue"
  import { useUserStore } from '@/stores/user'

  const userStore = useUserStore()

  const hasEventAccess = computed(() => {
    return userStore.accountType >= 4 || userStore.accountType === 1337
  })
</script>

<template>
  <div class="container pt-5">
    <div class="heading-container">
      <div class="d-flex centered column">
        <h1 class="text-center jura mb-4">Search Netflow</h1>
        <p style="max-width: 900px;" class="text-center mb-5">
          Query logs using Lucene syntax to investigate connections, identify patterns, and analyze traffic across your data sources.
        </p>
      </div>
    </div>

    <div class="search-widget-wrapper">
      <EventSearchWidget v-if="hasEventAccess"/>
      <div v-else class="upgrade-prompt">
        <font-awesome-icon :icon="['fas', 'lock']" class="upgrade-icon" />
        <p class="upgrade-message">Netflow Search requires an Elite or Enterprise subscription</p>
      </div>
    </div>

    <div class="history-wrapper">
      <SearchHistory filterType="event"/>
    </div>
  </div>
</template>

<style scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.heading-container {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  padding-top: 1rem;
}

.search-widget-wrapper {
  flex-shrink: 0;
}

.history-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.upgrade-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  background-color: rgba(255, 255, 255, 0.02);
  border-radius: 0.75rem;
  text-align: center;
}

.upgrade-icon {
  font-size: 2rem;
  color: #6B7280;
  margin-bottom: 1rem;
  opacity: 0.6;
}

.upgrade-message {
  color: #9CA3AF;
  font-size: 0.95rem;
  margin: 0 0 1rem 0;
}
</style>
